import { __rest } from "tslib";
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { MD5 } from 'crypto-js';
import lodashGet from 'lodash/get';
import { FoldIcon, UnfoldIcon } from './icon/foldAvatar';
import styles from './imUserAvatar.module.scss';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import IconCard from '@web-common/components/UI/IconCard';
const realStyles = classNames.bind(styles);
const computeAvatarColor = (str) => {
    let numStr = str.replace(/[^\d]/g, '');
    const strlMd5 = MD5(numStr).toString();
    const finalCharcode = strlMd5.charCodeAt(strlMd5.length - 1);
    return finalCharcode % 6;
};
export const FoldAvatar = ({ fold }) => (React.createElement("div", { style: { backgroundColor: '#F4F4F5' }, className: realStyles('defaultAvatar') }, fold ? React.createElement(FoldIcon, null) : React.createElement(UnfoldIcon, null)));
export const UserAvatar = props => {
    const { enableClick = false, user, avatarSize = 32, testId = '' } = props;
    if (lodashGet(props, 'user.avatar.length', 0) !== 0) {
        return (React.createElement(AvatarTag, { className: realStyles('defaultAvatar', {
                enableClick,
            }), testId: testId, size: avatarSize, contactId: user === null || user === void 0 ? void 0 : user.contactId, propEmail: user === null || user === void 0 ? void 0 : user.email, user: {
                name: (user === null || user === void 0 ? void 0 : user.nick) || '',
                avatar: user.avatar,
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
            } }));
    }
    return (React.createElement(AvatarTag, { className: realStyles('defaultAvatar', {
            enableClick,
        }), testId: testId, size: avatarSize, contactId: user === null || user === void 0 ? void 0 : user.contactId, propEmail: user === null || user === void 0 ? void 0 : user.email, user: {
            name: (user === null || user === void 0 ? void 0 : user.nick) || '',
            color: (user === null || user === void 0 ? void 0 : user.color) || '#6557FF',
            email: (user === null || user === void 0 ? void 0 : user.email) || '',
        } }));
};
export const TeamAvatar = props => {
    const { teamId, enableClick, teamInfo = null, hasHover = false, avatarSize = 32, discussGroup = false, testId = '' } = props, restProps = __rest(props, ["teamId", "enableClick", "teamInfo", "hasHover", "avatarSize", "discussGroup", "testId"]);
    const avatarIndex = computeAvatarColor(teamId) || 0;
    const avatar = useMemo(() => {
        if (lodashGet(teamInfo, 'avatar.length', 0)) {
            return React.createElement("img", { src: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.avatar, className: realStyles('teamAvatar'), alt: "" });
        }
        if (discussGroup) {
            return React.createElement("div", { className: `im-user-avatar-color ${realStyles('teamAvatarColor')} ${realStyles('teamDiscussGroup')}` });
        }
        return React.createElement("div", { className: `im-user-avatar-color ${realStyles('teamAvatarColor')} ${realStyles('teamAvatarColor' + avatarIndex)}` });
    }, [teamId, teamInfo]);
    return (React.createElement("div", Object.assign({ className: realStyles('defaultAvatar', {
            enableClick,
        }), style: { width: avatarSize, height: avatarSize } }, restProps, { "data-test-id": testId }),
        hasHover && (React.createElement("div", { className: styles.hoverBg },
            React.createElement(IconCard, { type: "camera" }))),
        avatar));
};
